import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row !important;

  @media (max-width: 1100px) {
    flex-direction: column !important;
  }
`;

export const Tabs = styled.div`
  display: flex;
  flex-direction: column;

  height: 36rem;

  @media (max-width: 1400px) {
    height: 32rem;
  }

  @media (max-width: 1100px) {
    width: 100%;
    height: fit-content;

    flex-direction: row;

    margin-bottom: 4rem;
  }

  @media (max-width: 500px) {
    margin-bottom: 2rem;
  }
`;

type TabProps = {
  selected: boolean;
  color: string;
  timer: string;
};

export const Tab = styled.button<TabProps>`
  width: fit-content;
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  border-right: 2px solid ${({ theme }) => theme.colors.gray2};

  svg {
    width: 2rem;
    height: 2rem;

    color: ${({ selected, color, theme }) =>
      selected ? color : theme.colors.gray2};
    transition: color 0.2s ease-in-out;

    align-self: center;

    margin: 2.5rem 1.25rem;
  }

  ${({ selected, theme }) =>
    !selected &&
    css`
      &:hover {
        border-right: 2px solid ${theme.colors.gray4};

        svg {
          color: ${theme.colors.gray4};
        }
      }
    `}

  ${({ selected, color, theme, timer }) =>
    selected &&
    css`
      background: linear-gradient(
        270deg,
        ${color} -245.83%,
        ${theme.colors.white} 63.19%
      );

      @media (max-width: 1100px) {
        background: linear-gradient(
          360deg,
          ${color} -245.83%,
          ${theme.colors.white} 63.19%
        );
      }

      > div {
        width: 2px;
        height: 0px;

        margin-right: -2px;

        background: ${color};
        animation: border-timer ${timer} forwards;

        @media (max-width: 1400px) {
          animation: border-timer-1400 ${timer} forwards;
        }

        @media (max-width: 1100px) {
          width: 0;
          height: 2px;

          margin-right: 0;
          margin-bottom: -2px;

          animation: border-timer-1100 ${timer} forwards;
        }

        @media (max-width: 500px) {
          animation: border-timer-500 ${timer} forwards;
        }
      }
    `}

  @media (max-width: 1400px) {
    svg {
      width: 1.75rem;
      height: 1.75rem;

      margin: 1.95rem 1rem;
    }
  }

  @media (max-width: 1100px) {
    width: 100%;
    height: 100%;

    flex-direction: column;

    border-right: 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.gray2};

    svg {
      align-self: center;
    }

    ${({ selected, theme }) =>
      !selected &&
      css`
        &:hover {
          border-right: 0;
          border-bottom: 2px solid ${theme.colors.gray4};
        }
      `}
  }

  @media (max-width: 500px) {
    svg {
      width: 1.5rem;
      height: 1.5rem;

      margin: 2rem 1rem;
    }
  }

  @keyframes border-timer {
    from {
      height: 0rem;
    }

    to {
      height: 100%;
    }
  }

  @keyframes border-timer-1400 {
    from {
      height: 0rem;
    }

    to {
      height: 100%;
    }
  }

  @keyframes border-timer-1100 {
    from {
      width: 0rem;
    }

    to {
      width: 100%;
    }
  }

  @keyframes border-timer-500 {
    from {
      width: 0rem;
    }

    to {
      width: 100%;
    }
  }
`;

export const Content = styled.div`
  height: 36rem;
  margin-left: 5rem;

  @media (max-width: 1400px) {
    height: 32rem;
  }

  @media (max-width: 1100px) {
    height: 100%;
    margin-left: 0;
  }
`;
